import { render } from "./BackAnketaView.vue?vue&type=template&id=b1d77b60&scoped=true"
import script from "./BackAnketaView.vue?vue&type=script&lang=js"
export * from "./BackAnketaView.vue?vue&type=script&lang=js"

import "./BackAnketaView.vue?vue&type=style&index=0&id=b1d77b60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d77b60"]])

export default __exports__